module.exports = __webpack_public_path__ + "img/security.bf51d00b.jpg";